<template>
  <router-view></router-view>
</template>

<script>
import { Trans } from '@/plugins/translation.js';
import { LANG_CODE_VIETNAMESE, LANG_CODE_JAPANESE } from '@/common/constants';
export default {
  components: {},

  methods: {
    checkLangFromRouter() {
      const { query } = this.$route;

      if (
        query.lang &&
        (query.lang == LANG_CODE_VIETNAMESE || query.lang == LANG_CODE_JAPANESE)
      ) {
        this.$store.dispatch('changeLanguage', { lang: query.lang });
        Trans.changeLanguage(query.lang);
      }
    }
  },

  watch: {
    $route: function () {
      // this.checkLangFromRouter();
    }
  },

  created() {
    // this.checkLangFromRouter();
  }
};
</script>

<style lang="scss" scoped>
@import '../style/devices.scss';
.auth-container {
  height: 100vh;
  position: relative;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  height: 50px;
}

@include mobile {
  .footer-fixed {
    position: unset !important;
    bottom: 0;
    height: 50px;
  }
}
</style>
